import styled from "styled-components";
import Paragraph from "../components/Typography/Paragraph";
import Container from "../components/Wrappers/Container";
import Wrapper from "../components/Wrappers/Wrapper";
import Spacer from "../components/Utils/Spacer";
import { useEffect, useState } from "react";
import Loader from "../components/Animations/Loader";
import Heading from "../components/Typography/Heading";
import { RadioGroup } from "../components/Form/FormStyles";
import ProductCard from "../components/Layout/ProductCard";
import { isAuthenticated, getUsers, getMyGrocery, blockGrocery, unblockGrocery } from "../api";
import { Link, useParams } from "react-router-dom";
import { DarkColor } from "../components/Utils/TextColorUtils";
import Prompt from "../components/Generics/Prompt";
import Button from "../components/Generics/Button";

interface Iparams {
  sellerId: string;
}
const GroceryGrid = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  align-items: flex-start;
  gap: 2rem;
`;
const Content = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--white);
  box-shadow: var(--shadow-smooth);
  border-radius: var(--radius-md);
  overflow: hidden;
`;
const Image = styled.img`
  width: 18.5rem;
  display: inline-block;
`;
const Info = styled.div`
  padding: 1rem;
  color: var(--grey-dark-1);
`;

const Bold = styled.span`
  font-weight: 600;
`;
const SellerAndGrocery = () => {
  const [seller, setSeller] = useState({} as IUser);
  const [grocery, setGrocery] = useState({} as IGrocery);
  const [loading, setLoading] = useState(false);
  const [promptShown, setPromptShown] = useState(false);
  const [action, setAction] = useState("");
  const { sellerId } = useParams<Iparams>();
  const showPrompt = (action: string) => {
    setPromptShown(true);
    setAction(action);
  };
  const removePrompt = () => {
    setPromptShown(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Minha Conta | BAZARAQUI";
  }, []);
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const { token } = isAuthenticated();
      // eslint-disable-next-line
      const $seller = await getUsers(token, `\/${sellerId}`);
      setSeller($seller);

      const $grocery = await getMyGrocery(sellerId);
      setGrocery($grocery);
      setLoading(false);
    };
    init();
  }, [sellerId]);
  
  const handleSubmit = async () => {
    const { token } = isAuthenticated();
    setLoading(true);
    if(action === "disable") {
      await blockGrocery(grocery._id, token);
    }else await unblockGrocery(grocery._id, token);
    setGrocery({ ...grocery, active: !grocery.active });
    setLoading(false);
  }

  return (
    <Wrapper>
      {loading ? <Loader /> : null}

      <Container>
        <Prompt
          onConfirm={handleSubmit}
          message={` ${action === "disable" ? "DESABILITAR": "HABILITAR"} ${grocery.name}?`}
          visible={promptShown}
          close={removePrompt}
        />
        <Content>
          <Image src={seller.photo} alt="nome do usuario" />
          <Info>
            <Paragraph weight="normal">{seller.province}, {seller.district}, {seller.address}</Paragraph>
            <Heading weight="bolder" size="md">
              {seller.name}
            </Heading>
            <Paragraph><DarkColor>Banca: </DarkColor>
              <Link to={`/grocery/${grocery.slug}`}>{grocery.name}, </Link>
              <Link to={`/market/${grocery.market && grocery.market.id}`}>{grocery.market && grocery.market.name}</Link> </Paragraph>
            <Spacer />
            <Paragraph weight="normal">
              <Bold>Pagamentos: </Bold> {grocery.paymentMethods && grocery.paymentMethods.map(method => `${method} `)}
            </Paragraph>
            <Paragraph weight="normal">
              <Bold>Contacto: </Bold>+258 {seller.phoneNumber}
            </Paragraph>
          </Info>
        </Content>
        <Spacer size="md" />

        <Heading size="md" weight="bolder">
          Actividade de venda ({grocery.active ? "HABILITADA" : "DESABILITADA"})
        </Heading>
        <Spacer />
        <RadioGroup>
          {grocery.active ?
            <Button color="cancel" action={() => showPrompt("disable")}>Desabilitar</Button>
            :
            <Button color="success" action={() => showPrompt("enable")}>Habilitar</Button>
          }
        </RadioGroup>
        <Spacer />
        <Heading size="md" weight="bolder">
          Produtos
        </Heading>
        <GroceryGrid>
          {grocery.products && grocery.products.length ? grocery.products.map(product => (
            <ProductCard
              name={product.name}
              image={product.image}
              price={product.priceVariations}
              page="/edit-product/product"
              action={() => { }}
            />
          )) : <Paragraph>Nenhum Produto</Paragraph>}
        </GroceryGrid>
      </Container>
    </Wrapper>
  );
};

export default SellerAndGrocery;
